import './AffiliatePanel.scss';
import React, { useEffect, useState } from 'react';
import { AffiliateModel } from '@mm/state/model/AffiliateModel';
import { compose } from 'recompose';
import { StoreState } from '@mm/state/store-interfaces';
import { Dispatch } from 'redux';
import AffiliatesCRUDActions from '@mm/state/actions/AffiliatesCRUDActions';
import { connect } from 'react-redux';
import modalActions from '@mm/state/modules/modalsState/actions';
import AffiliateInfo from './AffiliateInfo/AffiliateInfo';
import AffiliateResources from './AffiliateResources/AffiliateResources';
import PaneSection from '../../../../common/components/PaneSection/PaneSection';

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;

const AffiliatePanel = ({
  affiliate,
  fetchAffiliateForCurrentUser,
  deactivateAffiliate,
}: Props) => {
  const [fetchComplete, setFetchComplete] = useState(false);

  const fetchOnMount = async () => {
    await fetchAffiliateForCurrentUser();

    setFetchComplete(true);
  };

  useEffect(() => {
    fetchOnMount();
  }, []);

  if (!fetchComplete) {
    return null;
  }

  return (
    <PaneSection
      title="Referrals"
      className="affiliate-panel__pane-header"
      headerRightSection={null}
    >
      <AffiliateInfo affiliate={affiliate} />
      <AffiliateResources />
      {affiliate?.approved && (
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            deactivateAffiliate(affiliate);
          }}
          className="affiliate-panel__deactivate-link"
        >
          Deactivate my affiliate link
        </a>
      )}
    </PaneSection>
  );
};

const mapStateToProps = (state: StoreState) => ({
  affiliate: state.affiliates.affiliate,
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  fetchAffiliateForCurrentUser: () =>
    dispatch(AffiliatesCRUDActions.fetchForCurrentUser()),
  deactivateAffiliate: (affiliate: AffiliateModel) =>
    dispatch(modalActions.openDeactivateAffiliateModal(affiliate)),
});

const enhance = compose<Props, never>(
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(AffiliatePanel);
